import React from 'react';
import Stack from '@mui/material/Stack';
import ProficiencyDots from './proficiencyDots';
import TypographyWithI18N from './TypographyWithI18N';
import { useTranslation } from 'react-i18next';

interface ICandidateSkillRatingProps {
  name: string;
  rating?: string;
  showAvg?: boolean;
}

const CandidateSkillRating = ({
  name,
  rating,
  showAvg,
}: ICandidateSkillRatingProps) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction='row'
      spacing={3}
      height='1.25rem'
      sx={{ overflow: 'auto', display: 'flex', flexWrap: 'wrap' }}
    >
      <Stack sx={{ flex: 1 }}>
        <TypographyWithI18N
          title={t(name) as string}
          i18nKey={name}
          id={`skill-${name}`}
          data-testid={`skill-${name}`}
          className='kfic2-bodyTextSmall'
          sx={{
            whiteSpace: 'nowrap',
            width: '9.8rem',
          }}
        />
      </Stack>
      <Stack sx={{ flex: 1 }}>
        <ProficiencyDots rating={rating} showAvgRating={showAvg} count={5} />
      </Stack>
    </Stack>
  );
};

export default CandidateSkillRating;
